import { render, staticRenderFns } from "./DeliveryWalletRequests.vue?vue&type=template&id=5e3db35f&scoped=true"
import script from "./DeliveryWalletRequests.vue?vue&type=script&lang=js"
export * from "./DeliveryWalletRequests.vue?vue&type=script&lang=js"
import style0 from "./DeliveryWalletRequests.vue?vue&type=style&index=0&id=5e3db35f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3db35f",
  null
  
)

export default component.exports